import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {SizeProp} from "@fortawesome/fontawesome-svg-core";

export const timeoutInMS = (delay: number) => {
    return new Promise(res => setTimeout(res, delay));
}

const CopyMail = (props:{iconSize?:SizeProp}) => {
    const [openAlert, setOpenAlert] = useState(false)
    const {t} = useTranslation()
    const onClick = async () => {
        await navigator.clipboard.writeText("jaimejcorralgarcia@gmail.com")
        setOpenAlert(true)
        await timeoutInMS(2500)
        setOpenAlert(false)
    }

    return (
        <div onClick={onClick}
             className={"relative inline-flex touch-manipulation items-center gap-1.5 whitespace-nowrap cursor-pointer " +
                 "transition-colors hover:text-accent hover:underline"}>
            {openAlert &&
                <div onClick={(e) => {
                    e.stopPropagation()
                    setOpenAlert(false)
                }
                }
                     className={"absolute bottom-[120%] left-1/2 -translate-x-1/2 z-10 whitespace-nowrap " +
                         "rounded-lg border border-borderLight dark:border-borderDark " +
                         "bg-surfaceLight dark:bg-surfaceDark px-3 py-1.5 text-sm no-underline shadow-lg"}>
                    <div>{t("common.mailCopied")}</div>
                </div>}
            jaimejcorralgarcia@gmail.com
            <div className={"inline"}>
                <FontAwesomeIcon size={props.iconSize?props.iconSize:"sm"} icon={faCopy}/>
            </div>
        </div>
    )
}

export default CopyMail
